module.exports = __webpack_public_path__ + "static/img/agb_5.1aeeb69.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/agb_5.png
// module id = 1255
// module chunks = 1